module.exports = __webpack_public_path__ + "static/media/icon-1024.6bd8ec8b.png";